import { create } from 'zustand';

/**
 * Session-level flag to prevent the /t layout from redirecting
 * back to /t/requested-details after the user skips or completes onboarding.
 * Resets on page refresh (intentional — re-check pending forms on new session).
 */
interface OnboardingDismissedState {
  dismissed: boolean;
  dismiss: () => void;
}

export const useOnboardingDismissed = create<OnboardingDismissedState>()((set) => ({
  dismissed: false,
  dismiss: () => set({ dismissed: true }),
}));
